import httpClient from '../httpClient';

export async function getArpItem(id: string) {
  try {
    const response = await httpClient.get(`/api/arp-item/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllArpsItens() {
  try {
    const response = await httpClient.get(`/api/arp-item`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getItensPorArp(id: string) {
  try {
    const response = await httpClient.get(`/api/arp-item/arp/${id}`);
    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter dados da Incorporação no SUS: ' + error);
  }
}
